import { firebaseNormalizer } from "./global";

export const selectStudentsByGroupKey = (state, groupKey) => {
  const { users, groups } = state.firebase;
  const group = groups && groups.byId[groupKey];
  return (
    (group &&
      group.studentIds &&
      group.studentIds.map(studentId => {
        const user = users.byId[studentId];
        return user;
      })) ||
    []
  );
};

export const selectGroupByKey = (state, groupKey) => {
  const groups = firebaseNormalizer(state, "groups");
  const filteredGroup = groups.filter(group => group.key === groupKey)[0]
  return filteredGroup

};

export const selectGroupsByColegio = (state, col) => {
  const grupos = firebaseNormalizer(state, "groups");
  const filteredInfo = x => x.colegio === col;
  return filteredInfo(grupos);
};
